const ACCEPTED_STATUS_VALUES = new Set(["3", "accepted", "approved", "yes", "y"]);
const EXPLICIT_NON_ACCEPTED_STATUS_VALUES = new Set(["2", "pending", "4", "rejected", "no", "n"]);

function hasNonEmptyValue(value: unknown): boolean {
  return value !== null && value !== undefined && String(value).trim() !== "";
}

function hasLinkedProjectId(quotation: any): boolean {
  const candidates = [
    quotation?.LinkedProjectId,
    quotation?.linkedProjectId,
    quotation?.ProjectId,
    quotation?.projectId,
  ];

  return candidates.some((value) => {
    if (!hasNonEmptyValue(value)) {
      return false;
    }

    const parsed = Number(String(value).trim());
    return Number.isFinite(parsed) ? parsed > 0 : true;
  });
}

function hasAcceptedDate(quotation: any): boolean {
  const acceptedDate = quotation?.AcceptedDate ?? quotation?.acceptedDate;
  if (!hasNonEmptyValue(acceptedDate)) {
    return false;
  }

  if (acceptedDate instanceof Date) {
    return !Number.isNaN(acceptedDate.getTime());
  }

  const trimmed = String(acceptedDate).trim();
  const parsedTime = new Date(trimmed).getTime();
  return Number.isFinite(parsedTime) || trimmed.length > 0;
}

export function isAcceptedStatusValue(value: unknown): boolean {
  const normalized = String(value || "").trim().toLowerCase();
  return ACCEPTED_STATUS_VALUES.has(normalized);
}

export function isAcceptedQuotationLike(quotation: any): boolean {
  const normalized = String(
    quotation?.Acceptance
    || quotation?.acceptance
    || quotation?.Status
    || quotation?.status
    || quotation?.statusCode
    || ""
  ).trim().toLowerCase();

  if (EXPLICIT_NON_ACCEPTED_STATUS_VALUES.has(normalized)) {
    return false;
  }

  return ACCEPTED_STATUS_VALUES.has(normalized) || hasLinkedProjectId(quotation) || hasAcceptedDate(quotation);
}
